/**
 * Страница всех проектов — окошки как на Latest works.
 */

import { useNavigate } from "react-router-dom";
import { PROJECTS } from "../config/projects";
import ProjectCard from "../components/ProjectCard/ProjectCard";
import "../components/ProjectCard/ProjectCard.css";
import "./ProjectsPage.css";

function ProjectsPage() {
    const navigate = useNavigate();

    const handleAction = (project) => {
        if (project.action === "order") {
            navigate("/contact", { state: { scrollToForm: true } });
            return;
        }
        if (project.path) {
            navigate(project.path);
        }
    };

    return (
        <div className="projects-page">
            <div className="projects-page__grid">
                {PROJECTS.map((project) => (
                    <ProjectCard
                        key={project.id}
                        project={project}
                        onAction={handleAction}
                    />
                ))}
            </div>
        </div>
    );
}

export default ProjectsPage;
// pages/ProjectsPage.js
